module.exports = __webpack_public_path__ + "static/media/se.d7365199.svg";